import {DefaultUrlSerializer, UrlSerializer, UrlTree} from "@angular/router";
import { Injectable } from "@angular/core";

@Injectable()
export class CustomUrlSerializer implements UrlSerializer {
  parse(url: any): UrlTree {
    return new DefaultUrlSerializer().parse(url);
  }

  serialize(tree: UrlTree): any {
    const path = new DefaultUrlSerializer().serialize(tree);
    return path.replace(/\%2B/g,'+');
  }
}
